enum RelativeOperationTypes {
    ADD = '+',
    SUBTRACT = '-',
}

export default RelativeOperationTypes;
